import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";

const ScanConfirmModal = ({
  isOpen,
  scanText,
  title,
  confirmLabel,
  onConfirm,
  onCancel,
  loading,
}) => (
  <Modal isOpen={isOpen} toggle={loading ? undefined : onCancel} centered>
    <ModalHeader toggle={loading ? undefined : onCancel}>{title}</ModalHeader>
    <ModalBody>
      <p className="text-muted small mb-2">Scanned content:</p>
      <div className="font-monospace border rounded p-3 bg-light text-break">
        {scanText}
      </div>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" outline disabled={loading} onClick={onCancel}>
        Cancel
      </Button>
      <Button color="primary" disabled={loading} onClick={onConfirm}>
        {loading ? (
          <>
            <Spinner size="sm" className="me-2" />
            Working…
          </>
        ) : (
          confirmLabel
        )}
      </Button>
    </ModalFooter>
  </Modal>
);

export default ScanConfirmModal;
